import { reactSdkContextFactory } from 'launchdarkly-react-client-sdk';

export const flagsContext = reactSdkContextFactory();
